export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USER_BY_ID = 'FETCH_USER_BY_ID'
export const CLEAR_USER_BY_ID = 'CLEAR_USER_BY_ID' 
export const FETCH_OPERATION_GROUPS = 'FETCH_OPERATION_GROUPS'
